import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-label-performance',
  templateUrl: './status-label-performance.component.html',
  styleUrls: ['./status-label-performance.component.scss']
})
export class StatusLabelPerformanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
